import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useI18n } from "../lib/i18n";
import { AuthShell, Field, SubmitBtn } from "../components/AuthShell";

export default function Login() {
  const { t } = useI18n();
  const { setSession } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setSession(data.token, data.user);
      toast.success("Uspešno ste prijavljeni.");
      navigate("/");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title={t("login_title")}>
      <form onSubmit={submit}>
        <Field label={t("email")} testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
        <Field label={t("password")} testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
        <div className="flex justify-end mb-5">
          <Link to="/forgot-password" data-testid="login-forgot-link" className="font-mono text-xs text-white/50 hover:text-nhgreen transition-colors">
            {t("forgot_password")}
          </Link>
        </div>
        <SubmitBtn loading={loading} testid="login-submit">{t("submit_login")}</SubmitBtn>
      </form>
      <p className="font-mono text-xs text-white/50 mt-6 text-center">
        {t("no_account")}{" "}
        <Link to="/register" data-testid="login-to-register" className="text-nhgreen hover:underline">
          {t("nav_register")}
        </Link>
      </p>
    </AuthShell>
  );
}
